@if (dataState(); as state) {
  @if (state.state === 'loading') {
    <app-loading-card [loadingText]="'BFP.UI.Loading'" />
  } @else {
    <app-biomass-benchmark-widget [dataState]="state" />
  }
}
